import formatOrderDate from "./formatOrderDate";

export default function CouvertureDate(Date1Inf:string, Date1Sup:string, Date2Inf: string, Date2Sup: string ) {
    return (formatOrderDate(Date2Inf)<=formatOrderDate(Date1Inf) && formatOrderDate(Date1Inf)<=formatOrderDate(Date2Sup)) && ((formatOrderDate(Date2Inf)<=formatOrderDate(Date1Sup) && formatOrderDate(Date1Sup)<=formatOrderDate(Date2Sup)))
}